import { IPost } from '_interfaces/post.interface';
import { IPostComment } from '_interfaces/postComment.interface';

export const fuzzySearch = (text: string, query: string): boolean => {
  if (!query.trim()) return true;

  const normalizedText = text.toLowerCase().trim();
  const normalizedQuery = query.toLowerCase().trim();

  // Exact match
  if (normalizedText.includes(normalizedQuery)) return true;

  // Fuzzy match - check if all query characters appear in order
  let queryIndex = 0;
  for (let i = 0; i < normalizedText.length && queryIndex < normalizedQuery.length; i++) {
    if (normalizedText[i] === normalizedQuery[queryIndex]) {
      queryIndex++;
    }
  }

  return queryIndex === normalizedQuery.length;
};

export const extractTextFromHtml = (html: string): string => {
  if (!html) return '';

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
};

export const postMatchesSearch = (post: IPost, query: string): boolean => {
  if (!query.trim()) return true;

  const messageText = extractTextFromHtml(post.message);
  return fuzzySearch(messageText, query);
};

export const commentMatchesSearch = (comment: IPostComment, query: string): boolean => {
  if (!query.trim()) return true;

  const messageText = extractTextFromHtml(comment.message);
  return fuzzySearch(messageText, query);
};
